import { render } from "./donate.vue?vue&type=template&id=60bea861&scoped=true"
import script from "./donate.vue?vue&type=script&lang=js"
export * from "./donate.vue?vue&type=script&lang=js"

import "./donate.vue?vue&type=style&index=0&id=60bea861&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60bea861"]])

export default __exports__